import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import './GuestFilter.scss';

class GuestFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedGuestCount: 1,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && this.props.loading) {
      this.props.closeFilter('guest');
    }

    // Update state with already applied filters
    if (
      nextProps.open !== this.props.open &&
      nextProps.appliedGuestCount &&
      nextProps.appliedGuestCount !== this.state.selectedGuestCount
    ) {
      this.setState({ selectedGuestCount: nextProps.appliedGuestCount });
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (
      this.props.mobile &&
      this.state.selectedGuestCount !== nextState.selectedGuestCount
    ) {
      this.props.updateMobileFilters('guest', nextState.selectedGuestCount);
    }
  }

  updateSelectedWithApplied = () => {
    if (this.props.appliedGuestCount) {
      this.setState({ selectedGuestCount: this.props.appliedGuestCount });
    }
  };

  filterButtonClicked = () => {
    if (this.props.open) {
      this.props.closeFilter('guest');
    } else {
      this.props.openFilter('guest');
    }
  };

  handleClickOutside = (_evt) => {
    if (this.props.open && !this.props.loading && !this.props.mobile) {
      this.props.closeFilter('guest');
      this.clearFilter();
    }
  };

  applyGuestFilter = () => {
    this.props.applyFilter('guest', this.state.selectedGuestCount);
  };

  // Resets guest count back to 0
  clearFilter = () => {
    this.setState({ selectedGuestCount: 1 });
  };

  // Clears and applies reset
  clearAndApply = () => {
    this.clearFilter();
    this.props.applyFilter('guest', 1);
  };

  incrementCount = () => {
    this.setState((prevState) => ({
      selectedGuestCount: prevState.selectedGuestCount + 1,
    }));
  };

  decrementCount = () => {
    this.setState((prevState) => {
      if (prevState.selectedGuestCount > 1) {
        return { selectedGuestCount: prevState.selectedGuestCount - 1 };
      }
      return null;
    });
  };

  filterLabel = () => {
    const { open } = this.props;

    let guests = 0;
    if (open) {
      guests = this.state.selectedGuestCount;
    } else {
      guests = this.props.appliedGuestCount;
    }

    if (!guests || guests === 0 || guests === 1) {
      return 'Guests';
    }

    return `${guests} Guests`;
  };

  allowApply = () => {
    if (this.props.loading) return true;

    const { selectedGuestCount } = this.state;
    const { appliedGuestCount } = this.props;

    if (selectedGuestCount === appliedGuestCount) {
      return false;
    }

    if (selectedGuestCount === 1) {
      if (!appliedGuestCount) return false;
      if (appliedGuestCount > 1) return true;
    }

    return true;
  };

  renderSelector = () => {
    return (
      <div className="selectorRow">
        <div className="name">Guests</div>
        <div className="selector">
          <div
            role="button"
            aria-label="Increase guests"
            className={`selectorButton left brand-color ${
              this.state.selectedGuestCount <= 1 ? 'disabled' : ''
            }`}
            onClick={this.decrementCount}
          >
            &#8722;
          </div>
          <div className="quantity">{this.state.selectedGuestCount}</div>
          <div
            role="button"
            aria-label="Decrease guests"
            className="selectorButton right brand-color"
            onClick={this.incrementCount}
          >
            &#43;
          </div>
        </div>
      </div>
    );
  };

  renderClearButton = () => {
    if (this.state.selectedGuestCount > 1) {
      return (
        <div className="clearButton brand-color" onClick={this.clearAndApply}>
          Clear
        </div>
      );
    }
    return <div />;
  };

  renderMobile = () => {
    return (
      <div className="filterBody guestFilter mobile">
        <div className="heading">Number of Guests</div>
        <div className="selectorRow">
          <div className="selector">
            <div
              role="button"
              aria-label="Decrease guests"
              className={`selectorButton left ${
                this.state.selectedGuestCount <= 1 ? 'disabled' : ''
              }`}
              onClick={this.decrementCount}
            >
              <i className="icon af-minus-ar brand-color" />
            </div>
            <div className="quantity">{this.state.selectedGuestCount}</div>
            <div
              role="button"
              aria-label="Decrease guests"
              className="selectorButton right"
              onClick={this.incrementCount}
            >
              <i className="icon af-plus-ar brand-color" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (!this.props.enabled) return null;
    if (this.props.mobile) return this.renderMobile();

    return (
      <div className="filter">
        <div
          className={`filterButton brand-border
            ${this.props.open ? 'open brand-bg' : null}
            ${this.props.filterApplied ? 'filterApplied brand-bg' : null}`}
          onClick={this.filterButtonClicked}
        >
          {this.filterLabel()}
        </div>

        <div
          className={`filterPopover arrow-top ${
            this.props.open ? '' : 'hidden'
          }`}
        >
          <div className="filterBody guestFilter">
            {this.renderSelector()}
            <div className="filterActions">
              {this.renderClearButton()}
              <div
                role="button"
                aria-label="Apply"
                className={`applyButton submitButton ui fluid button anygreen brand-bg
                ${this.props.loading ? 'loading' : null}
                ${this.allowApply() ? '' : 'disabled brand-bg'}
                `}
                onClick={this.applyGuestFilter}
              >
                Apply
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default onClickOutside(GuestFilter);
